import React from 'react';
import headerImage from '../assets/images/header.png';
import '../styles/TempStart.css';

function TempStart() {
  return (
    <main className="temp-start">
      <img src={headerImage} alt="HomeCrowd" className="temp-start-logo" />
      <p className="temp-start-status">Under construction</p>
    </main>
  );
}

export default TempStart;
